import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ResultServerActionType } from '@headless-workspace/core-domain';
import { useSafeSWRMutation } from '@headless-workspace/domain/common/client';
import { TriggerWithArgs } from 'swr/mutation';
import { getReviewTranslationServerAction, ReviewTranslationPayload, ReviewTranslationValue } from '../../../../server';

type MutationTriggerReturnType = TriggerWithArgs<
    ResultServerActionType<ReviewTranslationValue>,
    unknown,
    typeof CacheKeys.ReviewTranslation,
    ReviewTranslationPayload
>;

type UseReviewTranslationReturnType = {
    translate: MutationTriggerReturnType;
    isTranslating: boolean;
};

export const useTranslateReviewMutation = (): UseReviewTranslationReturnType => {
    const { trigger: translationTrigger, isMutating } = useSafeSWRMutation<
        ReviewTranslationValue,
        ReviewTranslationPayload
    >(
        CacheKeys.ReviewTranslation,
        ServerActionName.getReviewTranslation,
        async (_, { arg }) => await getReviewTranslationServerAction(arg),
    );

    return {
        translate: translationTrigger,
        isTranslating: isMutating,
    };
};
